import React from "react"

function Cog({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5458 11.49C16.2022 12.3145 15.2388 12.687 14.4277 12.3127C13.0857 11.6933 11.6934 13.0857 12.3128 14.4276C12.6871 15.2387 12.3146 16.2022 11.49 16.5457C10.1974 17.0843 10.1974 18.9155 11.49 19.4541C12.3146 19.7977 12.6871 20.7612 12.3128 21.5722C11.6934 22.9142 13.0857 24.3065 14.4277 23.6871C15.2388 23.3127 16.2022 23.6852 16.5458 24.5098C17.0844 25.8025 18.9156 25.8025 19.4542 24.5098C19.7977 23.6852 20.7612 23.3127 21.5722 23.6871C22.9142 24.3065 24.3066 22.9142 23.6872 21.5722C23.3128 20.7612 23.6853 19.7977 24.5099 19.4541C25.8026 18.9155 25.8026 17.0843 24.5099 16.5457C23.6853 16.2022 23.3128 15.2387 23.6872 14.4276C24.3066 13.0857 22.9142 11.6933 21.5722 12.3127C20.7612 12.687 19.7977 12.3145 19.4542 11.49C18.9156 10.1974 17.0844 10.1974 16.5458 11.49Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 18C20.5 19.3807 19.3807 20.5 18 20.5C16.6192 20.5 15.5 19.3807 15.5 18C15.5 16.6192 16.6192 15.5 18 15.5C19.3807 15.5 20.5 16.6192 20.5 18Z"
        stroke="#003E4C"
        strokeWidth="1"
      />
    </svg>
  )
}
export default Cog
